export const container = ({ width, reverse }) => ({
    width,
    minHeight: '34.375rem',
    position: 'relative',
    display: 'flex',
    flexDirection: reverse ? 'column-reverse' : 'column',
    justifyContent: 'space-around',
    marginRight: '24px',

    tablet: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },

    tabletLarge: {
        paddingLeft: '6.25rem',
        paddingRight: '6.25rem',
    },
});

export const title = ({ theme: { fonts } }) => ({
    ...fonts.heroNewBold,
    tablet: {
        ...fonts.heroNewBold,
        fontSize: '3rem',
        marginBottom: '1.5625rem',
        marginTop: '4.6875rem',
    },
});

export const contentContainer = {
    width: '100%',
    tablet: {
        width: '50%',
    },
};

export const link = ({ theme: { colors } }) => ({
    color: colors.blue,
    fontSize: '1.25rem',
    fontWeight: 'bold',
    textDecoration: 'none',
    borderBottom: `0.125rem solid ${colors.blue}`,
    willChange: 'color',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    marginTop: '0.5rem',
    display: 'inline',

    '&:hover': {
        color: colors.fuchsia,
    },
});
